import React from 'react'

const ProfileSectionWK = ({ section }) => {
  if (!section.additional) {
    return null
  }

  return (
    <div className="assessment-section">
      <p>
        The scores below would confer a <b>{section.additional.certificateType}</b>{' '}
        certificate.
      </p>
      <ul className="assessment">
        {section.additional.skills
          .filter(s => s.hasOwnProperty('value'))
          .map(r => (
            <li key={r.elementId}>
              <b>{r.elementName}</b> <span>{r.value}</span>
            </li>
          ))}
      </ul>
      <p>
        For more information about these scores, please visit the{' '}
        <a href="/workkeys">Work Keys</a> section.
      </p>
    </div>
  )
}

export default ProfileSectionWK
